import React, { useCallback, useMemo } from "react";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";

interface AddCustomBodyComponentProps {
    section: {
        id: number;
        bodyCopy?: string;
    };
    onChange: (id: number, updatedData: Partial<any>) => void;
    onClose: () => void;
}

const AddCustomBodyComponent: React.FC<AddCustomBodyComponentProps> = ({
                                                                           section,
                                                                           onChange,
                                                                           onClose,
                                                                       }) => {
    const ReactQuill = require("react-quill");
    console.log(section.bodyCopy);

    const modules = useMemo(
        () => ({
            toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link", "image"],
                ["clean"],
            ],
            keyboard: {
                bindings: {
                    customEnter: {
                        key: 13,
                        handler: function (this: any, range: any) {
                            const quill: Quill = this.quill;
                            const [line, offset] = quill.getLine(range.index);
                            const textBefore = line.domNode.textContent
                                .slice(0, offset)
                                .trim();
                            const textAfter = line.domNode.textContent
                                .slice(offset)
                                .trim();

                            // Double line break only on empty line
                            if (!textBefore && !textAfter) {
                                quill.insertText(range.index, "\n\n");
                            } else {
                                quill.insertText(range.index, "\n");
                            }

                            quill.setSelection(range.index + 1, "silent");
                            return false;
                        },
                    },
                },
            },
        }),
        []
    );

    const handleBodyChange = useCallback(
        (value: string) => {
            onChange(section.id, { bodyCopy: value });
        },
        [section.id, onChange]
    );

    const cleanBody = useMemo(() => {
        // Use the saved HTML directly — no space normalization
        if (!section.bodyCopy?.trim()) return "";
        return section.bodyCopy;
    }, [section.bodyCopy]);

    return (
        <div
            style={{
                padding: "10px",
                position: "relative",
                marginBottom: "10px",
                border: "1px solid #ddd",
                borderRadius: "5px",
            }}
        >
            <button
                style={{
                    position: "absolute",
                    top: 5,
                    right: 5,
                    border: "none",
                    background: "none",
                    color: "black",
                    cursor: "pointer",
                }}
                onClick={onClose}
            >
                X
            </button>

            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>
                Body Content
            </label>

            <ReactQuill
                value={cleanBody}
                onChange={handleBodyChange}
                modules={modules}
                theme="snow"
                style={{
                    width: "100%",
                    minHeight: "150px",
                    marginTop: "10px",
                }}
                placeholder="Enter body content here..."
            />
        </div>
    );
};

export default AddCustomBodyComponent;
